export default __webpack_public_path__ + "static/media/gallery_06.eb27435e.jpg";